import React from 'react';
import $ from 'jquery';
import './style.scss';

const ModalExtraRegisterIframe = () => {
  return (
    <div
      className='modal fade modal-extra-register-iframe'
      id='modal-extra-register-iframe'
    >
      <div
        className='modal-dialog modal-dialog-centered'
        role='document'
        id='register-extra-iframe'
      ></div>
    </div>
  );
};

export default ModalExtraRegisterIframe;
